import React from "react";

const ProjectDelaysTable = ({ delaysTable, setDelaysTable }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...delaysTable];
    updated[rowIndex][field] = value;
    setDelaysTable(updated);
  };

  const addRow = () => {
    setDelaysTable([
      ...delaysTable,
      {
        projectName: "",
        numberOfDelays: "",
        totalDurationDays: "",
        rootCause: "",
        correctiveActions: "",
        status: "", // Ongoing / Resolved
      },
    ]);
  };

  const removeRow = () => {
    if (delaysTable.length > 1) {
      setDelaysTable(delaysTable.slice(0, -1));
    }
  };

  return (
    <div>
      {/* Table Container */}
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#d0c5ca", color: "#000" }}>
              <th style={tableHeaderStyle}>Project Name</th>
              <th style={tableHeaderStyle}>Number of Delays</th>
              <th style={tableHeaderStyle}>Total Duration (Days)</th>
              <th style={tableHeaderStyle}>Root Cause</th>
              <th style={tableHeaderStyle}>Corrective Actions</th>
              <th style={tableHeaderStyle}>Status (Ongoing/Resolved)</th>
            </tr>
          </thead>
          <tbody>
            {delaysTable.map((row, index) => (
              <tr key={index}>
                {/* Project Name */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.projectName}
                    onChange={(e) =>
                      handleInputChange(index, "projectName", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                {/* Number of Delays (number only) */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={row.numberOfDelays}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (/^\d*$/.test(v)) {
                        handleInputChange(index, "numberOfDelays", v);
                      }
                    }}
                    style={inputFieldStyle}
                  />
                </td>

                {/* Total Duration (Days) (number only) */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    inputMode="numeric"
                    value={row.totalDurationDays}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (/^\d*$/.test(v)) {
                        handleInputChange(index, "totalDurationDays", v);
                      }
                    }}
                    style={inputFieldStyle}
                  />
                </td>

                {/* Root Cause */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.rootCause}
                    onChange={(e) =>
                      handleInputChange(index, "rootCause", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                {/* Corrective Actions */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.correctiveActions}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "correctiveActions",
                        e.target.value
                      )
                    }
                    style={inputFieldStyle}
                  />
                </td>

                {/* Status (Ongoing/Resolved) */}
                <td style={tableCellStyle}>
                  <select
                    value={row.status}
                    onChange={(e) =>
                      handleInputChange(index, "status", e.target.value)
                    }
                    style={inputFieldStyle}
                  >
                    <option value="">Select</option>
                    <option value="Ongoing">Ongoing</option>
                    <option value="Resolved">Resolved</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default ProjectDelaysTable;
